module.exports = __webpack_public_path__ + "static/img/application5-1.313cace.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application5/application5-1.jpg
// module id = GVoi
// module chunks = 0